import { defineMessages } from 'react-intl'

export default defineMessages({
  noOption: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.noOption',
    defaultMessage: 'No result for {query}',
  },
  languagePlaceholder: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.language.placeholder',
    defaultMessage: 'Select language',
  },
  productPlaceholder: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.product.placeholder',
    defaultMessage: 'Select product',
  },
  nameLabel: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.name.label',
    defaultMessage: 'Demo title',
  },
  productLabel: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.product.label',
    defaultMessage: 'Product',
  },
  languageLabel: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.language.label',
    defaultMessage: 'Language',
  },
  namePlaceholder: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.name.placeholder',
    defaultMessage: 'Enter demo title',
  },
  dialectPlaceholder: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.dialect.placeholder',
    defaultMessage: 'Select Dialect',
  },
  accentPlaceholder: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.accent.placeholder',
    defaultMessage: 'Select Accent',
  },
  saveLabel: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.save.label',
    defaultMessage: 'Save',
  },
  deleteLabel: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.delete.label',
    defaultMessage: 'Delete',
  },
  errorHelp: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.error.help',
    defaultMessage: 'Help me fix this',
  },
  errorsPresent: {
    id: 'containers.SupplierProfile.components.DemoInlineEditor.error.present',
    defaultMessage: 'the field is required',
  },
})
